import React from 'react';
import { Button, Space } from 'antd';
import {useTranslation} from 'react-i18next';
import { StyledTableFiltersDivider } from '../../TransactionsPage/TableFilters/StyledTableFilters';

const TableFiltersRightSideContent = ({
  availableExport = false,
  availableSync = true,
  exportButtonProps = {},
  exportButtonText,
  syncButtonProps = {},
  syncButtonText,
}) => {
  const [t] = useTranslation('main');
  return (
    <Space size={0}>
      {availableExport && (
        <Button
          type='default'
          size='large'
          {...exportButtonProps}
        >
          {exportButtonText || t('export')}
        </Button>
      )}
      {availableSync && (
        <>
          <StyledTableFiltersDivider type='vertical' />
          <Button
            type='primary'
            size='large'
            {...syncButtonProps}
          >
            {syncButtonText || t('sync')}
          </Button>
        </>
      )}
    </Space>
  )
};

export default TableFiltersRightSideContent;
